/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetCompanySettingsResponseData,
  GetCompanySettingsResponseDataFromJSON,
  GetCompanySettingsResponseDataFromJSONTyped,
  GetCompanySettingsResponseDataToJSON
} from './GetCompanySettingsResponseData'

/**
 *
 * @export
 * @interface GetCompanySettingsResponse
 */
export interface GetCompanySettingsResponse {
  /**
   *
   * @type {number}
   * @memberof GetCompanySettingsResponse
   */
  status?: number
  /**
   *
   * @type {GetCompanySettingsResponseData}
   * @memberof GetCompanySettingsResponse
   */
  data?: GetCompanySettingsResponseData
}

export function GetCompanySettingsResponseFromJSON(json: any): GetCompanySettingsResponse {
  return GetCompanySettingsResponseFromJSONTyped(json, false)
}

export function GetCompanySettingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCompanySettingsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetCompanySettingsResponseDataFromJSON(json['data'])
  }
}

export function GetCompanySettingsResponseToJSON(value?: GetCompanySettingsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetCompanySettingsResponseDataToJSON(value.data)
  }
}
